/* -----------------------------------------------
   TD 2026-10-23 INLET-SET — "Therapiedecke (Inlett) dazu" on the cover pages (snippets/td-inlet-set.liquid).
   Felix 23.10.2026: "add to all covers as first upsell … an inner blanket so it becomes a set (blanket + cover) … also
   10% — this has more priority than the 10% off second same cover".
   Loaded only when an inlet box is shown (module: runs once per page). assets/custom.js (initTdUpsellAddon) does the
   switch, the weight chips, the price, the thumbnail and the add-to-cart request; this file does two things:
   - Follow the page's selection: on every variant:change of the product form the box of the chosen cover's system
     (Schlaufen → inlet with loops, Reißverschluss → inlet with zip) is shown with the cover's size (hidden size input +
     a change event, so custom.js picks the inlet variant and repaints the price), the other box is hidden. Which box and
     which size come from the cover's variant map (data-td-inlet-map, built in Liquid). A switched-on box stays on when the
     system changes (the other box takes over); a cover variant without a fitting inlet hides both boxes and switches them
     off. A box custom.js gave up on (could not go into the cart: window.tdAddonGone) stays hidden. custom.js hides the
     block item only when no offer in it is usable any more (Codex R1); a box that fits later brings the item back.
   - Priority over "Zweiten Bezug dazu −10%" (the second-unit box of the same form, data-td-addon-same): the two exclude
     each other. With both on, the cart would give the set's 10% only — the second cover's 10% is lost when both covers
     cost the same (measured 23.10.2026) — so switching one on switches the other off (a change event, so custom.js and
     assets/td-second-unit.js update). The inlet box says so in its note.
   ----------------------------------------------- */
(() => {
  if (window.tdInletSetReady) return;
  window.tdInletSetReady = true;

  const groups = () => Array.from(document.querySelectorAll('[data-td-inlet-group]'));
  const formIdOf = (group) => group.dataset.tdInletFormId || '';
  const mapOf = (group) => {
    const script = group.querySelector('script[data-td-inlet-map]');
    try {
      return script ? JSON.parse(script.textContent || '{}') : {};
    } catch (error) {
      return {};
    }
  };
  const boxesOf = (group) => Array.from(group.querySelectorAll('[data-td-upsell-addon][data-td-inlet-kind]'));
  const toggleOf = (box) => (box ? box.querySelector('[data-td-upsell-toggle]') : null);
  const isOn = (box) => {
    const toggle = toggleOf(box);
    return !!(toggle && toggle.checked);
  };
  /* custom.js keeps "<form id>|<handle>" of add-ons that could not go into the cart until the next page load */
  const isGone = (box) => {
    const gone = window.tdAddonGone;
    return !!(gone && typeof gone.has === 'function' && gone.has(`${box.dataset.tdUpsellFormId || ''}|${box.dataset.tdUpsellHandle || ''}`));
  };
  const secondBoxesOf = (formId) => Array.from(document.querySelectorAll('[data-td-upsell-addon][data-td-addon-same]'))
    .filter((box) => box.dataset.tdUpsellFormId === formId);
  const inletBoxesOf = (formId) => groups().filter((group) => formIdOf(group) === formId).flatMap(boxesOf);
  const currentVariantId = (group) => {
    const form = document.getElementById(formIdOf(group));
    const input = form ? form.querySelector('[name="id"]') : null;
    return input ? String(input.value || '') : '';
  };

  /* switch a box on / off like a click would (custom.js listens to the change event) */
  let silent = false;
  const setOn = (box, on) => {
    const toggle = toggleOf(box);
    if (!toggle || toggle.checked === on) return;
    toggle.checked = on;
    silent = true;
    try {
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      silent = false;
    }
  };

  const apply = (group, variantId) => {
    const entry = mapOf(group)[String(variantId)] || null;
    const boxes = boxesOf(group);
    const wasOn = boxes.some((box) => !box.hidden && isOn(box));
    let target = null;
    boxes.forEach((box) => {
      const fits = !!(entry && entry.k === box.dataset.tdInletKind && entry.s) && !isGone(box);
      if (!fits) {
        setOn(box, false);
        box.hidden = true;
        return;
      }
      target = box;
      box.hidden = false;
      const size = box.querySelector('[data-td-inlet-size]');
      if (size && size.value !== entry.s) {
        size.value = entry.s;
        size.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const fit = box.querySelector('[data-td-inlet-fit]');
      if (fit && typeof entry.f === 'string') fit.textContent = entry.f;
    });
    if (target && wasOn) setOn(target, true);
    /* custom.js hides the whole block item when its last usable offer failed (hideAddon): a box that fits now (the other
       inlet product, never one that failed) brings the block back */
    const item = target ? group.closest('.product-info__block-item') : null;
    if (item && item.hidden) item.hidden = false;
  };

  /* a browser that restored both switches as "on" (reload / back navigation): the set wins (Felix: priority) */
  const exclusive = (group) => {
    if (boxesOf(group).some((box) => !box.hidden && isOn(box))) secondBoxesOf(formIdOf(group)).forEach((other) => setOn(other, false));
  };

  const setup = (group) => {
    if (group.dataset.tdInletReady === 'true') return;
    group.dataset.tdInletReady = 'true';
    apply(group, currentVariantId(group));
    exclusive(group);
  };
  const setupAll = () => groups().forEach(setup);
  setupAll();

  /* the page's selection changed (theme.js VariantPicker: variant:change on the product form, bubbles) */
  document.addEventListener('variant:change', (event) => {
    const form = event.target;
    const formId = form && typeof form.getAttribute === 'function' ? form.getAttribute('id') : '';
    const variant = event.detail && event.detail.variant;
    if (!formId || !variant) return;
    groups().filter((group) => formIdOf(group) === formId).forEach((group) => {
      setup(group);
      apply(group, variant.id);
    });
  });

  /* one of the two offers switched on: the other one goes off */
  document.addEventListener('change', (event) => {
    const toggle = event.target;
    if (silent || !toggle || !toggle.matches || !toggle.matches('[data-td-upsell-toggle]') || !toggle.checked) return;
    const box = toggle.closest('[data-td-upsell-addon]');
    if (!box) return;
    const formId = box.dataset.tdUpsellFormId || '';
    if (box.hasAttribute('data-td-inlet-kind')) {
      secondBoxesOf(formId).forEach((other) => setOn(other, false));
    } else if (box.hasAttribute('data-td-addon-same')) {
      inletBoxesOf(formId).forEach((other) => setOn(other, false));
    }
  });

  /* a product change replaces the whole product info: set up the new boxes after assets/custom.js has (both wait a tick) */
  document.addEventListener('product:rerender', () => window.setTimeout(setupAll, 0), true);
  /* back / forward cache: the browser may restore another selection */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) groups().forEach((group) => { apply(group, currentVariantId(group)); exclusive(group); });
  });
})();
